import React from 'react';
import { CoachCard } from '../shared/CoachCard';
import { Button } from '../shared/Button';
export const CoachesSection = () => {
  const coaches = [{
    name: 'David Hopper',
    role: 'Founder, Head Career Strategist',
    image: 'https://cdn.prod.website-files.com/65dcdc8067ad38483fe3b6b4/671006d53eeff7a8654800bf_Image%20(1).jpg',
    bio: 'David has worked with 3,800+ software engineers over the last 10 years, helping them land roles across FAANG and top startups. Known for his "Keystone Role" method and in-depth "game tape" interview reviews, David specializes in helping senior engineers command higher compensation and land roles aligned with long-term goals.',
    linkedin: 'https://www.linkedin.com/in/dphopper/'
  }, {
    name: 'Michelle Lai',
    role: 'Executive Career Coach',
    image: 'https://cdn.prod.website-files.com/65dcdc8067ad38483fe3b6b4/682e2c7193a984ad8d436762_1670362856795%20(1).jpeg',
    bio: 'Michelle brings over a decade of experience working with directors, managers, and senior ICs through career pivots and strategic transitions. She is a master of narrative development, positioning, and behavioral interview prep. Michelle was also a Software Engineer at Dolby, Eventbrite, Sony, and more.',
    linkedin: 'https://www.linkedin.com/in/michellai/',
    website: 'http://reflectedworth.com/'
  }];
  return <section className="w-full bg-gradient-to-br from-[#231232] to-[#1a0d24] py-24" data-id="element-96">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-97">
        <div className="text-center mb-16" data-id="element-98">
          <h2 className="text-4xl font-outfit font-bold mb-6 text-white" data-id="element-99">
            Meet Your Team
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-100">
            Learn from industry veterans who have helped hundreds of engineers
            land their dream roles at top tech companies.
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto mb-16" data-id="element-101">
          {coaches.map(coach => <CoachCard key={coach.name} {...coach} data-id="element-102" />)}
        </div>
        <div className="text-center" data-id="element-103">
          <Button variant="secondary" href="/start" data-id="element-104">
            Book a Call With Our Coaches
          </Button>
        </div>
      </div>
    </section>;
};